import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {react} from "mobx";
import {
    Button, FormGroup, Form,
    Input,
    Label,
    Table,
    Row, Col
} from 'reactstrap'
import 'moment/locale/pt-br';
import moment from "moment";

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

import {LancamentoHoras} from "../components/LancamentoHoras";
import HorasExtrasStore from "../stores/HorasExtrasStore";
import DataWrapper from "../../../principal/containers/DataWrapper";
import _ from 'lodash';
import {getNomeFluxosById} from "../../../../utils/enums";
import {DetalhamentoRecursoMOT} from "../components/DetalhamentoRecursoMOT";
import {FormWithActions} from "../../../comum/components/FormWithActions";
import {DetalhamentoHistorico} from "../../comum/components/DetalhamentoHistorico";
import {Redirect} from "react-router-dom";
import {DetalhamentoSolicitante} from "../../comum/components/DetalhamentoSolicitante";
import {DetalhamentoJustificativa} from "../../comum/components/DetalhamentoJustificativa";
import {formatarValorReal} from "../../../../utils/formatar";
import {LoadingPanel} from "../../../comum/components/LoadingPanel";
import {DetalhamentoTotal} from "../components/DetalhamentoTotal";
import {ResumoLancamento} from "../components/ResumoLancamento";
import {DetalhamentoEmpregadosSubstituidos} from "../../comum/components/DetalhamentoEmpregadosSubstituidos";
import {RateioProdutos} from "../components/RateioProdutos";

@inject("store")
@DataWrapper
@observer
export class DetalhesHorasExtras extends Component {

    constructor(props) {
        super(props);

        this.appState = this.props.store.appState;
        this.aprovacao = this.props.aprovacao;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.formStore = this.props.store.formStore;
        this.modalStore = this.props.store.modalStore;
        this.validacaoStore = this.props.store.validacaoStore;
        this.loginStore = this.props.store.loginStore;
        this.loadingPanelStore = this.props.store.loadingPanelStore;


        this.controller = new HorasExtrasStore(this.tituloPaginaStore, this.loginStore, this.loadingPanelStore);

    }

    componentDidMount() {
        if (_.get(this.props, "match.params.taskIdBpm")) {
            this.controller.carregarDados(_.get(this.props, "match.params.taskIdBpm"));
        } else {
            this.controller.carregarDadosLotePagamento(_.get(this.props, "match.params.timesheetId"));
        }

        this.tituloPaginaStore.setTitulo("Horas trabalhadas")
    }

    save() {
        this.controller.rows[this.indexToSave] = this.controller.rowSelected;
        this.controller.modalIsOpen = !this.controller.modalIsOpen;
    }

    render() {
        if (this.formStore.acaoEnviada) {
            return <Redirect to="/horas-trabalhadas-pendentes" />;
        } else {
            return this.renderForm();
        }
    }

    renderForm() {
        const lancamentos = [];
        const lancamentosMobile = [];
        const self = this;
        const aprovacao = this.aprovacao;


        return (
            <div>
                <div className="form-wrapper">
                    <LoadingPanel>
                        <div className="content-panel panel-sm">
                            <Form className="panel-form">
                                <FormWithActions controller={this.controller}
                                                 taskId={_.get(this.props, "match.params.taskIdBpm")}
                                                 tarefa={this.controller.nomeTarefa}
                                                 possiveisAcoes={this.controller.possiveisAcoes}
                                                 error={this.formStore.submitted && !this.modalStore.exibirModal.aberto && !this.validacaoStore.isValidForm}>
                                    <DetalhamentoSolicitante/>
                                    <DetalhamentoJustificativa/>
                                    <DetalhamentoEmpregadosSubstituidos />
                                    <DetalhamentoRecursoMOT/>
                                    <h4>Entrada timesheet</h4>
                                    <Row>
                                        <Col xs={12} md={4} lg={4}>
                                            <FormGroup>
                                                <Label>Competência</Label>
                                                <Input type="text" value={this.controller.competencia} readOnly/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={4} lg={4}>
                                            <FormGroup>
                                                <Label>Período</Label>
                                                <Input type="textF" value={moment(this.controller.timesheet.dataInicio).format("DD/MM/YYYY" + " - " + moment(this.controller.timesheet.dataFim).format("DD/MM/YYYY"))} readOnly/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={4} lg={4}>
                                            <FormGroup>
                                                <Label>Quantidade dias apurados</Label>
                                                <Input type="text" value={this.controller.quantidadeDias} readOnly/>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <h4>Lançamentos</h4>
                                    <LancamentoHoras
                                        listaLancamentoDias={this.controller.listaLancamentoDias}
                                        tiposHora={this.controller.tiposHora}
                                        onChange={(value, tipo) => this.controller.setListaLancamentoDias(value, tipo)}
                                        dataInicio={this.controller.timesheet.dataInicio}
                                        dataFim={this.controller.timesheet.dataFim}
                                        readOnly
                                    />
                                    <Row>
                                        <Col xs={12}>
                                            <FormGroup>
                                                <Label>Observações gerais</Label>
                                                <Input type="textarea" value={_.get(this.controller, "timesheet.observacoes")} readOnly/>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <ResumoLancamento/>
                                    <h4>Verbas</h4>
                                    <Row>
                                        {this.controller.exibeValorAche &&
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>Ache {this.controller.labelPercentualAche} <span
                                                    style={{fontSize: 10}}>(sobre salário base)</span></Label>
                                                <Input type="text"
                                                       value={formatarValorReal(this.controller.timesheet.valorAche)}
                                                       readOnly/>
                                            </FormGroup>
                                        </Col>
                                        }
                                        {this.controller.exibeCampoGdvNoLancamentoHoras &&
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>GDV qtd dias</Label>
                                                <Input type="text" value={this.controller.quandidadeDiasGDV} readOnly/>
                                            </FormGroup>
                                        </Col>
                                        }
                                        {this.controller.exibeValorGdv &&
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>GDV {this.controller.labelPercentualGdv} <span
                                                    style={{fontSize: 10}}>(sobre salário base)</span></Label>
                                                <Input type="text" value={formatarValorReal(this.controller.timesheet.valorGdv)} readOnly/>
                                            </FormGroup>
                                        </Col>
                                        }
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>Insalubridade <span style={{fontSize: 10}}>(sobre salário mínimo)</span></Label>
                                                <Input type="text" value={formatarValorReal(this.controller.timesheet.valorInsalubridade)} readOnly/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>Periculosidade <span
                                                    style={{fontSize: 10}}>(sobre salário base)</span></Label>
                                                <Input type="text" value={formatarValorReal(this.controller.timesheet.valorPericulosidade)} readOnly/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>Gratificação</Label>
                                                <Input type="text" value={formatarValorReal(this.controller.timesheet.valorGratificacao)} readOnly/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>DSR horas extras</Label>
                                                <Input type="text" value={formatarValorReal(this.controller.timesheet.valorDsrHorasExtras)} readOnly/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>DSR adicional noturno</Label>
                                                <Input type="text" value={formatarValorReal(this.controller.timesheet.valorDsrAdicionalNoturno)} readOnly/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>Outros proventos</Label>
                                                <Input type="text" value={formatarValorReal(this.controller.timesheet.valorOutrosProventos)} readOnly/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>Outros descontos</Label>
                                                <Input type="text" value={formatarValorReal(this.controller.timesheet.valorOutrosDescontos)} readOnly/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>VT</Label>
                                                <Input type="text" value={formatarValorReal(this.controller.timesheet.valorVt)} readOnly/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>VR</Label>
                                                <Input type="text" value={formatarValorReal(this.controller.timesheet.valorVr)} readOnly/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>ASO</Label>
                                                <Input type="text" value={formatarValorReal(this.controller.timesheet.valorAso)} readOnly/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>Reembolso de viagens</Label>
                                                <Input type="text" value={formatarValorReal(this.controller.timesheet.valorReembolsoViagens)} readOnly/>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <FormGroup>
                                                <Label>Observações sobre as verbas</Label>
                                                <Input type="textarea" value={_.get(this.controller, "timesheet.observacoesVerbasAdicionais")} readOnly/>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <DetalhamentoTotal />
                                    {this.controller.exibeRateioProdutos &&
                                        <RateioProdutos />
                                    }
                                    <h4>Centro de custo débito</h4>
                                    <Row>
                                        <Col xs={12} md={3} lg={4}>
                                            <FormGroup>
                                                <Label>Unidade de negócio (BU)</Label>
                                                <Input type="text" value={_.get(this.controller, "detalhes.empresaGlobo.nome")} readOnly/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={4}>
                                            <FormGroup>
                                                <Label>Centro de custo débito</Label>
                                                <Input type="text" value={ this.controller.descricaoArDebito } readOnly/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={4}>
                                            <FormGroup>
                                                <Label>Gestor centro de custo débito</Label>
                                                <Input type="text" value={_.get(this.controller, "detalhes.solicitacao.gestorAreaDebito.nome")} readOnly/>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <DetalhamentoHistorico />
                                </FormWithActions>
                            </Form>
                        </div>
                    </LoadingPanel>
                </div>
            </div>
        );
    }
}
